import { addQuotes, toStringify } from '../utils/smartutils';

export function findSchool() {
  const query = `{
  findSchool {
    id
    fantasyName
    reasonName
    cnpj
    subscription
    zipCode
    address
    addressNumber
    neighborhood
    responsible
    phoneOne
    phoneTwo
    phoneResponsible
    email
    emailResponsible
    startTime
    finalTime
    workingDays
    contractedPlan
    monthlyValue
    surplusPerStudent
    contractingDate
    activeStudents
    city
    state
    logoUrl
    smartGoSettings {
      smartGoDistance
      smartGoTime
      googleApiKey
    }
    schoolTransition
    smartpayEnable
    globalCity {value, label}
    uf {value, label}
    customizationVariables {
      id
      clientId
      primaryColor
      secondaryColor
      headerColor 
      fillColor 
      headerContentColor
    }
  }
}
`;
  return query;
}

export function updateSchoolData(values) {
  const query = `
  mutation{
      updateSchool(school:{
          id: ${values.id},
          fantasyName: "${values.fantasyName}",
          reasonName: "${values.reasonName}",
          cnpj: "${values.cnpj}",
          subscription: "${values.subscription}",
          zipCode: "${values.zipCode}",
          address: "${values.address}",
          addressNumber: "${values.addressNumber}",
          neighborhood: "${values.neighborhood}",
          city: "${values.city}",
          state: "${values.state}",
          responsible: "${values.responsible}",
          phoneOne: "${values.phoneOne}",
          phoneTwo: "${values.phoneTwo}",
          phoneResponsible: "${values.phoneResponsible}",
          email: "${values.email}",
          startTime: "${values.startTime}",
          finalTime: "${values.finalTime}",
          workingDays: "${values.workingDays.join(';')};",
          surplusPerStudent: 0,
          contractingDate: 0,
          activeStudents: 0, 
          monthlyValue: 0,
          contractedPlan: 0,
          active: true,
          overPlanValue: 0,
          smartGoSettings: {
              schoolId: ${values.id},
              smartGoDistance: ${values.smartGoSettings.smartGoDistance || 0},
              smartGoTime: ${values.smartGoSettings.smartGoTime || 0}
              googleApiKey: ${
                values.smartGoSettings.googleApiKey
                  ? addQuotes(values.smartGoSettings.googleApiKey)
                  : null
              }

          }
          customizationVariables: ${
            values.customizationVariables
              ? toStringify(values.customizationVariables)
              : null
          }
          schoolTransition: ${values.schoolTransition}
          smartpayEnable: ${values.smartpayEnable}
      }){id}
  }`;
  return query;
}

export const updateSchoolLogo = (values, fileUrl) => {
  return `mutation {
  updateSchoolLogo(
    school: {
      id: ${values.id}
      surplusPerStudent: 0
      contractingDate: 0
      activeStudents: 0
      monthlyValue: 0
      contractedPlan: 0
      active: true
      overPlanValue: 0
      logoUrl: ${addQuotes(fileUrl)}
      schoolTransition: false
      smartpayEnable: false
    }
  ) {
    id
  }
}
`;
};

export function schoolWorkingDays() {
  return `{findSchool{startTime, finalTime, workingDays}}`;
}
